import React, { useRef, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { ChatWindow } from './components/ChatWindow';
import { StatsPage } from './components/StatsPage';
import { DashboardPage } from './components/DashboardPage';
import { Message } from './components/MessageBubble';

const INITIAL_MESSAGES: Message[] = [
  { role: 'assistant', content: 'Dobrý deň! Som asistent obce Vinné. Opýtajte sa ma čokoľvek o obci.' },
];

function AppRoutes({ sessionId, sessionStart, sessionQueryCount, onQuerySent, messages, setMessages }: {
  sessionId: string;
  sessionStart: string;
  sessionQueryCount: number;
  onQuerySent: () => void;
  messages: Message[];
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
}) {
  const location = useLocation();
  const statsKeyRef = useRef(0);
  const prevPathRef = useRef(location.pathname);

  if (location.pathname === '/stats' && prevPathRef.current !== '/stats') {
    statsKeyRef.current += 1;
  }
  prevPathRef.current = location.pathname;

  return (
    <Routes>
      <Route path="/" element={
        <ChatWindow
          sessionId={sessionId}
          sessionStart={sessionStart}
          onQuerySent={onQuerySent}
          messages={messages}
          setMessages={setMessages}
        />
      } />
      <Route path="/stats" element={
        <StatsPage
          key={statsKeyRef.current}
          sessionStart={sessionStart}
          sessionQueryCount={sessionQueryCount}
        />
      } />
      <Route path="/stats/dashboard" element={<DashboardPage />} />
    </Routes>
  );
}

function App() {
  const [sessionId] = useState(() => crypto.randomUUID());
  const [sessionStart] = useState(() => new Date().toISOString());
  const [sessionQueryCount, setSessionQueryCount] = useState(0);
  const [messages, setMessages] = useState<Message[]>(INITIAL_MESSAGES);

  return (
    <ThemeProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <div className="app-shell">
          <AppRoutes
            sessionId={sessionId}
            sessionStart={sessionStart}
            sessionQueryCount={sessionQueryCount}
            onQuerySent={() => setSessionQueryCount((c) => c + 1)}
            messages={messages}
            setMessages={setMessages}
          />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
